var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCws(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 611.1 174.4",
    style: {
      enableBackground: "new 0 0 611.1 174.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EB0045;}\n\t.st1{fill:#231F20;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.75867,0,0,5.64148,-0.522633,-3.22367)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 0.6,
    className: "st0",
    width: 162.6,
    height: 30.9
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.75867,0,0,5.64148,-0.522633,0.8382)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.7,17.4c0.4,0,0.9,0.1,1.1,0.2c0.3,0.1,0.4,0.4,0.4,0.7c0,0.3-0.2,0.5-0.4,0.7c-0.2,0.1-0.6,0.2-1.1,0.2 H104v3h23.8c3.5,0,5.9-1.5,5.9-3.8s-2.4-3.8-6.1-3.8h-18.4c-0.4,0-0.8-0.1-1.1-0.2c-0.2-0.1-0.4-0.4-0.4-0.7s0.1-0.5,0.4-0.7 c0.2-0.1,0.6-0.2,1.1-0.2h23.6v-3h-23.6c-3.7,0-6.1,1.5-6.1,3.8s2.4,3.8,6.1,3.8C109.2,17.4,127.7,17.4,127.7,17.4z M97.4,9.9 l-11.8,8.3V9.9h-5L69,18.2V9.9h-5v12.3h5l11.5-8.1v8.1h5.3l18.1-12.3C103.9,9.9,97.4,9.9,97.4,9.9z M39,22.2 c-3.2,0-5.5-0.6-7.2-1.7S29.2,18,29.2,16c0-1.8,0.9-3.2,2.7-4.4c1.8-1.2,4.3-1.8,7.1-1.8h22.2v3H39.6c-1.9,0-3.1,0.2-4,0.8 c-1,0.6-1.4,1.4-1.4,2.4s0.6,1.8,1.6,2.4s2.2,0.8,4.3,0.8h21.1v3L39,22.2L39,22.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCws);
export default __webpack_public_path__ + "static/media/cws.4c8e3ffe5ff4b7d458ef9f17d4ea95bf.svg";
export { ForwardRef as ReactComponent };